<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <div style="float: left; position: relative; width: 70%; border-collapse: collapse; text-align: left">
                    <h4 class="m-b-0 text-white">Material</h4>
                </div>
            </div>
            <div class="card-body" id="padre">
                <!-- ======================================= -->
                <!-- ===== Select: Selecciona sucursal ===== -->
                <!-- ======================================= -->
                <div>
                    <tr>
                        <td>Selecciona el almacen de sucursal: &nbsp;</td>
                        <select class="form-control variosSelect" [(ngModel)]="idSucursal" (ngModelChange)="getMaterial()" name="sucursal">
                            <option *ngFor="let isucursal of sucursalesPertenecientes" [value]="isucursal.idSucursal">{{ isucursal.nombreSucursal }}</option>
                        </select>
                    </tr>
                </div>
                <hr>
                <!-- ======================================= -->
                <!-- ===== Select: Selecciona sucursal ===== -->
                <!-- ======================================= -->
                <!-- ================ -->
                <!-- ===== Mapa ===== -->
                <!-- ================ -->
                <div class="indexz">

                    <div id="map" style="height:300px;width: 100%;"></div>
                </div>
                <hr>
                <br>
                <!-- ================ -->
                <!-- ===== Mapa ===== -->
                <!-- ================ -->
                <!-- =========================== -->
                <!-- ===== Apoyo requerido ===== -->
                <!-- =========================== -->
                <div class="materiales" style="display:none;" id="materialesApoyo">
                    <h3>Lista de materiales que solicitan apoyo</h3>
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Cantidad apoyo</th>
                                <th>Cantidad en existencia</th>
                                <th>Cantidad a solicitar</th>
                                <th>Agregar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let producto of materialApoyo" style="text-align: center">
                                <td>{{ producto.codigoProducto }}</td>
                                <td>{{ producto.descripcion }}</td>
                                <td>{{ producto.cantidadApoyo }}</td>
                                <td>{{ producto.apoyoCantidadSucursal }}</td>
                                <td>
                                    <input class="form-control" style="width: 70px" type="number" id="{{producto.codigoProducto}}" min="0" name="{{producto.descripcion}}" [(ngModel)]="producto.cantidadSolicitada">
                                </td>
                                <td>
                                    <button class="btn btnAgregarProducto" type="button" (click)="agregarProducto(producto)">Agregar</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- =========================== -->
                <!-- ===== Apoyo requerido ===== -->
                <!-- =========================== -->
                <br>
                <!-- ================================== -->
                <!-- ===== Apoyo hacia sucursales ===== -->
                <!-- ================================== -->
                <div class="materiales">
                    <hr>
                    <h3 style="display:none;" id="tituloSegundaTabla">Lista de sucursales con materiales a solicitar</h3>
                    <table class="table table-striped" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th *ngFor="let campo of campos">{{campo}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let producto of test" style="text-align: center">
                                <td *ngFor="let rowProducto of producto">{{rowProducto}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <button class="float float-right btn btnSolicitarApoyo" style="display:none;" id="btnEnviarApoyo" (click)="solicitarApoyoSucursales()">Enviar solicitud de apoyo</button>
                </div>
                <!-- ================================== -->
                <!-- ===== Apoyo hacia sucursales ===== -->
                <!-- ================================== -->
                <!-- =================================== -->
                <!-- ===== Respuesta de sucursales ===== -->
                <!-- =================================== -->
                <div class="materiales" id="tablaRespuestaSucursales">
                    <hr>
                    <h3 id="tituloRespuestaSuc">Lista de sucursales que respondieron a la solicitud</h3>
                    <div>
                        <button class="btn btn-success float float-left" data-toggle="modal" data-target="#desplegarInforme" (click)="informe()">Informe</button>
                        <button class="btn btn-success float float-right" (click)="reiniciar()">Reiniciar</button>
                        <br>
                        <br>
                    </div>
                    <!-- style="display:none;" -->
                    <table class="display nowrap table table-hover table-striped table-bordered" id="tablaDinamica">
                        <thead>
                            <tr style="text-align: center">
                                <th *ngFor="let indice of indiceReverse">{{ indice }}</th>
                                <th>Listo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let respuestaSolicitud of arrayRespuestaSolicitud" style="text-align: center">
                                <td *ngFor="let contenido of respuestaSolicitud; let i=index">
                                    <div *ngIf="0 !== i && 1 !== i && 2 !== i && contenido !== 0; else otroTd">
                                        <input class="form-control" type="number" name="pudin" [(ngModel)]="respuestaSolicitud[i]" (ngModelChange)="flan(respuestaSolicitud, indiceReverse[i], i)">
                                    </div>
                                    <ng-template #otroTd>
                                        {{contenido}}
                                    </ng-template>
                                </td>
                                <td>{{respuestaSolicitud['total']}}</td>
                                <td *ngIf="respuestaSolicitud['total'] >= respuestaSolicitud[2]; else loContrario">
                                    <i class="mdi mdi-checkbox-marked" style="color:green"></i>
                                </td>
                                <ng-template #loContrario>
                                    <td><i class="mdi mdi-close-box-outline" style="color:red"></i></td>
                                </ng-template>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <button class="float float-right btn btnSolicitarApoyo " id="btnMoverBase " (click)="validacion() ">Aceptar materiales</button>
                </div>
                <!-- =================================== -->
                <!-- ===== Respuesta de sucursales ===== -->
                <!-- =================================== -->
            </div>
        </div>
    </div>
</div>
<!-- ========================== -->
<!-- ===== Modal Informes ===== -->
<!-- ========================== -->
<div class="modal fade" id="desplegarInforme" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3>Informe de apoyo</h3>
            </div>
            <div class="modal-body">
                <table class="display nowrap table table-hover table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Sucursal</th>
                            <th>Estatus</th>
                            <th>Producto</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let informe of arrayInforme">
                        <tr title="{{ informe.descripcion }}">
                            <td>{{ informe.sucursal }}</td>
                            <td style="text-align: left"><span class="label" [style.background]="informe.estatus.color">{{ informe.estatus.nombre }}</span></td>
                            <td>{{ informe.codigo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button class="btn btn-danger" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
<!-- ========================== -->
<!-- ===== Modal Informes ===== -->
<!-- ========================== -->


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-apoyo-traspaso/material-apoyo-traspaso.component.html